import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=05321dfc&scoped=true&"
import script from "./404Page.vue?vue&type=script&lang=js&"
export * from "./404Page.vue?vue&type=script&lang=js&"
import style0 from "./404Page.vue?vue&type=style&index=0&id=05321dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05321dfc",
  null
  
)

export default component.exports